'use strict';

var React = require('react');
require('prop-types');
var ObjectHelper = require('../../common/ObjectHelper.js');
var reactNumberFormat_es = require('../../node_modules/react-number-format/dist/react-number-format.es.js');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var makeStyles = require('../../DesignSystem/Styles/makeStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = makeStyles["default"](function (theme) {
  return {
    text: {
      color: theme.palette.common.white,
      textShadow: "1px 1px ".concat(theme.palette.common.black)
    },
    dataView: {
      height: '100%'
    }
  };
});

var PropertyDescriptor = function PropertyDescriptor(_ref) {
  var value = _ref.value,
      descriptor = _ref.descriptor;

  var _useStyles = useStyles(),
      text = _useStyles.text;

  return React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement(Typography, {
    variant: "body2",
    className: text
  }, value), React__default["default"].createElement(Typography, {
    variant: "caption",
    className: text
  }, descriptor));
};

var PropertyDataView = function PropertyDataView(_ref2) {
  var propertyData = _ref2.propertyData;

  var _useStyles2 = useStyles(),
      dataView = _useStyles2.dataView,
      text = _useStyles2.text;

  var estimate = propertyData.estimate,
      bedrooms = propertyData.bedrooms,
      bathrooms = propertyData.bathrooms,
      houseSize = propertyData.houseSize,
      yearBuilt = propertyData.yearBuilt;

  if (ObjectHelper.isBlank(propertyData)) {
    return null;
  }

  return React__default["default"].createElement(Grid, {
    container: true,
    direction: "column",
    alignItems: "flex-start",
    className: dataView
  }, ObjectHelper.isPresent(estimate) && React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    variant: "caption",
    className: text
  }, "Estimate"), React__default["default"].createElement(reactNumberFormat_es, {
    className: text,
    value: estimate,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    renderText: function renderText(value) {
      return React__default["default"].createElement(Typography, {
        variant: "body2",
        gutterBottom: true,
        className: text
      }, value);
    }
  })), ObjectHelper.isPresent(yearBuilt) && React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    gutterBottom: true,
    variant: "caption",
    className: text
  }, "Built in ", yearBuilt)), React__default["default"].createElement(Grid, {
    item: true,
    xs: true
  }, React__default["default"].createElement(Grid, {
    container: true,
    spacing: 16,
    justify: "flex-start"
  }, ObjectHelper.isPresent(bedrooms) && React__default["default"].createElement(Grid, {
    item: true,
    xs: "auto"
  }, React__default["default"].createElement(PropertyDescriptor, {
    value: bedrooms,
    descriptor: "Beds"
  })), ObjectHelper.isPresent(bathrooms) && React__default["default"].createElement(Grid, {
    item: true,
    xs: "auto"
  }, React__default["default"].createElement(PropertyDescriptor, {
    value: React__default["default"].createElement(reactNumberFormat_es, {
      value: bathrooms,
      displayType: "text",
      decimalScale: 1,
      fixedDecimalScale: true
    }),
    descriptor: "Baths"
  })), ObjectHelper.isPresent(houseSize) && React__default["default"].createElement(Grid, {
    item: true,
    xs: "auto"
  }, React__default["default"].createElement(PropertyDescriptor, {
    value: houseSize,
    descriptor: "Sq.ft."
  })))));
};

PropertyDataView.defaultProps = {
  propertyData: {}
};

module.exports = PropertyDataView;
